import { canonical } from "./pinyin.ts";

const SAY: ReadonlyMap<string, string> = new Map(([
  ["差 cha4", "岔"],
  ["地 de5", "的"],
  ["都 dou1", "兜"],
  ["教 jiao1", "交"],
  ["累 lei4", "类"],
  ["长 chang2", "常"],
  ["数 shu3", "鼠"],
  ["为 wei4", "位"],
  ["脏 zang1", "赃"],
  ["背 bei1", "杯"],
  ["重 chong2", "虫"],
  ["行 hang2", "航"],
  ["血 xie3", "写"],
  ["只 zhi1", "之"],
  ["薄 bao2", "雹"],
  ["处 chu4", "触"],
  ["打 da2", "达"],
  ["好 hao4", "耗"],
  ["划 hua2", "滑"],
  ["系 ji4", "记"],
  ["空 kong4", "控"],
  ["量 liang2", "粮"],
  ["应 ying1", "英"],
  ["种 zhong4", "众"],
  ["待 dai1", "呆"],
  ["将 jiang1", "江"],
  ["落 la4", "蜡"],
  ["散 san3", "伞"],
  ["扇 shan1", "山"],
  ["弹 tan2", "谈"],
  ["挣 zheng4", "证"],
  ["挨 ai2", "癌"],
  ["当 dang4", "荡"],
  ["杆 gan3", "敢"],
  ["觉 jiao4", "叫"],
  ["看 kan1", "堪"],
  ["露 lou4", "漏"],
  ["塞 sai1", "腮"],
  ["与 yu3", "雨"],
  ["涨 zhang4", "帐"],
  ["转 zhuan4", "赚"],
  ["唉 ai4", "爱"],
  ["剥 bao1", "包"],
  ["奔 ben4", "笨"],
  ["盛 cheng2", "成"],
  ["逮 dai3", "歹"],
  ["钉 ding4", "定"],
  ["缝 feng2", "逢"],
  ["晃 huang3", "谎"],
  ["结 jie1", "接"],
  ["尽 jin3", "紧"],
  ["圈 juan4", "倦"],
  ["刨 pao2", "袍"],
  ["漂 piao1", "飘"],
  ["呛 qiang1", "枪"],
  ["翘 qiao4", "俏"],
  ["削 xiao1", "消"],
  ["咽 yan4", "宴"],
  ["炸 zha2", "闸"],
  ["粘 zhan1", "沾"],
  ["传 zhuan4", "赚"],
  ["幢 zhuang4", "撞"],
] as const).map(([key, value]) => [canonical(key), value]));

export function homophone(word: string, pinyin: string): string | undefined {
  if ([...word].length !== 1) return undefined;
  return SAY.get(canonical(`${word} ${pinyin}`.normalize("NFC")));
}
